import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Home/index.vue'
Vue.use(VueRouter)

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/newsInfo',
    name: 'newsInfo',
    component: () => import('../views/Home/newsInfo.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About/index.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/Product/index.vue')
  },
  {
    path: '/culture',
    name: 'culture',
    component: () => import('../views/Culture/index.vue')
  },
  {
    path: '/joinus',
    name: 'joinus',
    component: () => import('../views/Joinus/index.vue')
  }
]

const router = new VueRouter({
  mode:'hash',
  routes
})

export default router
